const SET_ADMINISTRATION_MORE_PROCESSED_COMMENTS = (state, payload) => {
  const results = payload.origin.reportedComments.results;

  state.currentAdministrator.processedCommentsCount =
    payload.origin.reportedComments &&
    payload.origin.reportedComments.totalCount
      ? payload.origin.reportedComments.totalCount
      : 99999;

  if (results.length > 0) {
    const { processedComments } = state.currentAdministrator;

    state.currentAdministrator.processedComments = [
      ...processedComments,
      ...results,
    ];
  }
};

export default SET_ADMINISTRATION_MORE_PROCESSED_COMMENTS;
